import { makeStyles } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import DashboardLayout from '../../layout'
import { useData } from '../../../../data'
import { UploadOutlined } from '@ant-design/icons'
import { Form, Input, Upload, Button, DatePicker } from 'antd'
import { CTAButton } from '../../components'
import { trackPromise, usePromiseTracker } from 'react-promise-tracker'
import moment from 'moment'

const useStyles = makeStyles(theme => ({
    topBar: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        [theme.breakpoints.up('lg')]: {
            width: '30%'
        }
    },
    title: {
        fontSize: 24,
        fontWeight: 'bold',
        fontStyle: 'normal'
    },
    content: {
        marginTop: theme.spacing(2),
        display: 'flex',
        width: '100%',
        height: '100%',
        padding: '10px',
        flexDirection: 'column'
    },
    error: {
        fontSize: 18,
        color: 'red'
    },
    success: {
        fontSize: 18,
        color: 'green'
    },
    form: {
        maxWidth: '600px'
    }
}))

/**
 * Tools dashboard view page
 */
const AddFilePage = (props) => {
    const classes = useStyles()
    const [form] = Form.useForm()
    const [error, setError] = useState(null)
    const [success, setSuccess] = useState(null)
    const [status, setStatus] = useState({ currentBuildStatus: "", lastBuildStatus: "" })

    const { promiseInProgress } = usePromiseTracker()
    const data = useData()
    const uemail = data.uemail()

    let today = new Date()
    today = today.toISOString().split('T')[0]
    console.log(today)

    // load the current status
    const loadStatus = () => {
        trackPromise(
            uemail.getCurrentStatus()
                .then(res => {
                    setStatus({
                        currentBuildStatus: res.current_build_status,
                        lastBuildStatus: res.last_build_status
                    })
                    setError(null)
                })
                .catch(err => setError(err.message))

        )
    }

    useEffect(() => {
        loadStatus()
    }, [])
    useEffect(() => {
        const intervalId = setInterval(() => {
            loadStatus()
            // remove es-lint warning
        }, 10000)
        return () => clearInterval(intervalId);
    }, [])

    const { currentBuildStatus, lastBuildStatus } = status;

    const uploadFile = (vals) => {
        setError(null)

        // process the parametes 
        const { parameters = [] } = vals
        const params = {}

        for (let param of parameters) {
            const { param_key, param_value } = param

            params[param_key] = param_value
        }

        trackPromise(
            uemail.addFile({ ...vals, parameters: params })
                .then(res => {
                    setStatus({
                        currentBuildStatus: res.current_build_status,
                        lastBuildStatus: res.last_build_status
                    })
                    setError(null)
                })
                .catch(err => setError(err.message))
        )
    }

    // extract file details 
    const normFile = (e) => {

        if (Array.isArray(e)) {
            return e[0];
        }
        return e && e.fileList[0];
    };

    return (
        <DashboardLayout
            selected="email_universe"
        >
            <div className={classes.content}>
                <p className={classes.title}>Upload a File</p>
                <br />
                <p>
                    Upload a file and enter metadata to add the file to sources
                    which has to be built for upload to Google BigQuery. This
                    file will be added to <code>email-lists</code> git repository.
                </p>
                <p>
                    To update a file, change its content and upload it.
                </p>
                <p>Current build status: {currentBuildStatus}</p>
                <p>Last build status: {lastBuildStatus}</p>
                <Form
                    layout="horizontal"
                    onFinish={uploadFile}
                    form={form}
                    className={classes.form}
                    initialValues= {{
                        source: "crunchbase",
                        date: moment(today, 'YYYY-MM-DD'),
                        generator: "LGS",
                        category: "Fresh Contacts - Relevant Titles"
                    }}
                >
                    <Form.Item label="Source" name="source">
                        <Input />
                    </Form.Item>
                    <Form.Item label="Generator" name="generator">
                        <Input />
                    </Form.Item>
                    <Form.Item label="Category" name="category">
                        <Input />
                    </Form.Item>
                    <Form.Item label="Contact Scraping Method" name="contact_scraping_method">
                        <Input />
                    </Form.Item>
                    <Form.Item label="Linkedin Approach" name="linkedin_approach">
                        <Input />
                    </Form.Item>
                    <Form.Item label="Date" name="date">
                        <DatePicker />
                    </Form.Item>
                    <Form.Item
                        label="Input file"
                        name="input_file"
                        getValueFromEvent={normFile}
                        rules={[{ required: true, message: "Input file is required" }]}
                    >
                        <Upload
                            name="input_file"
                            accept=".csv, .xlsx"
                            beforeUpload={() => {
                                return false
                            }}
                            multiple={false}
                        >
                            <Button icon={<UploadOutlined />} > Upload File </Button>
                        </Upload>
                    </Form.Item>

                    <Form.Item >
                        <CTAButton type="submit" loading={promiseInProgress}>Submit</CTAButton>
                    </Form.Item>
                    {
                        error && (
                            <Form.Item >
                                <p className={classes.error}>An error occurred.</p>
                            </Form.Item>
                        )
                    }
                </Form>
            </div>
        </DashboardLayout>
    )
}

export default AddFilePage
